import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
export const Portal = ({ children, className = 'portal', element = 'div', }) => {
    const [container] = useState(document.createElement(element));
    className.split(' ').map((name) => container.classList.add(name));
    useEffect(() => {
        document.body.appendChild(container);
        return () => {
            document.body.removeChild(container);
        };
    }, []);
    return createPortal(children, container);
};
